import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type InitialState = {
  showAuthModal?: boolean
  showUserMenu?: boolean
  authRedirect?: string
}

const initialState: InitialState = {
  showAuthModal: false
}

export const stateSlice = createSlice({
  name: 'state',
  initialState,
  reducers: {
    setShowAuthModal: (
      state,
      action: PayloadAction<InitialState['showAuthModal'] | { show: boolean; redirect: string }>
    ) => {
      if (typeof action.payload === 'object') {
        state.showAuthModal = action.payload.show
        state.authRedirect = action.payload.redirect
        return
      }

      state.showAuthModal = action.payload
    },
    setShowUserMenu: (state, action: PayloadAction<InitialState['showUserMenu']>) => {
      state.showUserMenu = action.payload
    }
  }
})

export const { setShowAuthModal, setShowUserMenu } = stateSlice.actions
export default stateSlice.reducer
